"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const provider_components_1 = require("@kyruus/provider-components");
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const utils_1 = require("./utils");
const propTypes = {
    /** The config object for the customer */
    config: prop_types_1.object.isRequired,
    /** The care teams providers data from state machine context */
    careTeamsProviders: (0, prop_types_1.arrayOf)(prop_types_1.object),
    /** The services object containing URL creation functions */
    services: prop_types_1.object.isRequired,
    /** Tracking function */
    track: prop_types_1.func.isRequired
};
const defaultProps = {
    careTeamsProviders: null
};
/**
 * CareTeamsProviders component renders care team providers in the sidebar
 * using the same UI pattern as alt providers but with proper separation of concerns
 */
function CareTeamsProviders({ config, careTeamsProviders, services, track }) {
    const detailedCareTeamsProviders = (0, react_1.useMemo)(() => {
        return (0, utils_1.transformProvidersForDisplay)(careTeamsProviders, config);
    }, [careTeamsProviders, config]);
    // Don't render if no care teams providers data
    if (!detailedCareTeamsProviders.length) {
        return null;
    }
    return (react_1.default.createElement(styles_1.CareTeamsProvidersContainer, { "data-testid": "dbw-care-teams-providers" },
        react_1.default.createElement(styles_1.CareTeamsProvidersHeader, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.careTeamsProvidersHeader))),
        react_1.default.createElement(provider_components_1.MiniProviderCardList, { createAvailabilityUrl: services.createAvailabilityUrl, createProviderUrl: services.createProviderUrl, providers: detailedCareTeamsProviders, track: track })));
}
CareTeamsProviders.propTypes = propTypes;
CareTeamsProviders.defaultProps = defaultProps;
exports.default = CareTeamsProviders;
//# sourceMappingURL=CareTeamsProviders.js.map